// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormDnD.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormDnD
 */
!(function() {
  var AppGlobal = require('Izenda.AppGlobal');
  var droppable = require('share/components/hoc/Izenda.Droppable');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  var { constant } = require('lodash/fp');

  module.exports = function(component) {
    var targetOptions = {
      drop: function(props, monitor, com) {
        if (monitor.didDrop()) {
          return;
        }

        var reportPartContent = props.reportPart.reportPartContent;
        var item = monitor.getItem() || {};

        var fieldLimitValue = AppGlobal.advancedSettings.performance.fieldLimitValue;

        if (props.reportPart.fieldCollection.length >= fieldLimitValue) {
          props.confirmFn('Information', {
            description: ReportDesignerConstants.BUNDLE.MESSAGE.FIELDS_EXCEEDED_LIMITATION,
            type: 'error',
            showCloseIndicator: true
          });

          return;
        }

        if (item.querySourceField.isPredicated) {
          props.confirmFn('Information', {
            description: props.localization.getText('REPORTDESIGNER_FEATURE_NOT_AVAILABLE'),
            type: 'error',
            showCloseIndicator: true
          });

          return;
        }

        reportPartContent.updateContainerField();
        props.reportPart
          .insertFieldToContainer(reportPartContent.columns, item.querySourceField, item.dataObject)
          .then(function(addedField) {
            var code = reportPartContent.getHTMLCodeField(addedField, item.dataObject);

            reportPartContent.getEditorControl().insertContentDnD(code);

          });
      },

      canAccess: constant(true)
    };

    return droppable([ReportDesignerConstants.GENNERAL.FIELD_ITEM], targetOptions)(component);
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.ReportPartFormDnD.js